
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/debugger",
      function () {
        return require("private-next-pages/syncs/debugger.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/debugger"])
      });
    }
  